import React from "react";
import styles from "../AftersalesInformation/AftersalesInformation.module.css";
import {Section} from "../../../../../elements/section/Section";
import {FullLocationUi} from "../../../../../../api/generated";
import {LeftSideTextField} from "../../../../../elements/leftSideTextField/LeftSideTextField";

interface LocationDetailsProps {
    location: FullLocationUi
}

export const LocationEmailInformation: React.FC<LocationDetailsProps> = ({
                                                                             location
                                                                         }) => {

    return <Section title={"Location Transcript Notifications"}>
        <div className={styles.fieldsWrapper}>
            <LeftSideTextField
                title={"Transcript Recipient(s)"}
                value={(location.locationEmailTranscriptRecipients || []).join("; ")}
            />
            <LeftSideTextField
                title={"Transcript Filtration"}
                value={location.locationEmailFiltrationEnabled ? "Enabled" : "Disabled"}
            />
            <LeftSideTextField
                title={"Transcript Summary"}
                value={location.locationEmailTranscriptSummaryEnabled ? "Enabled" : "Disabled"}
            />
        </div>
    </Section>
}
